// extracted by mini-css-extract-plugin
export default {"header":"InputsArray_header__p9cMN","title":"InputsArray_title__TtBGh"};